import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import apiClient from "../../../../Api/ApiClient";
import apis from "../../../../Api/api.json";

import { Link } from "react-router-dom";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { format } from "date-fns";
import { CSVLink } from "react-csv";

export default function FormWeekly() {
  const [apiData, setApiData] = useState([]);
  const [exportData, setExportData] = useState([]); // For data export

  const columns = [
    { field: "id", headerName: "S.No", width: 50 },
    { field: "name", headerName: " Candidate Name", width: 150 },
    { field: "email", headerName: "Candidate Email", width: 200 },
    { field: "address", headerName: "Candidate Address", width: 200 },
    { field: "mobile_no", headerName: "Candidate  Mobile No.", width: 150 },
    {
      field: "View form data",
      headerName: "View For Data",
      sortable: false,
      width: 200,
      renderCell: (params) => (
        <Link to={"/feedback/formweekly/" + params.row.sno}>
          <InsertDriveFileIcon style={{ cursor: "pointer" }} />
        </Link>
      ),
    },
  ];

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiClient.get(
          "/api/FormReports/WeeklyCandidatedata",
        );
        const dataWithIds = response.data.map((row, index) => ({
          id: index + 1,
          ...row,
        }));
        setApiData(dataWithIds);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    // Fetch data for export
  async function fetchExportData() {
  try {
    let finalData = [];

    const response = await apiClient.get(`/api/FormReports/WeeklyCandidatedata`); //API Call

    for (let item of response.data) {
      const id = item.sno; 

      const detailRes = await apiClient.get(`/api/Weeklyaccount/${id}`);
      const d = detailRes.data;

      if (!d) continue;

     finalData.push({
  "Weekly account": d.weekly_account,

  "Account period start week date": d.account_period_start_week_date
    ? `\u200B${format(new Date(d.account_period_start_week_date), "dd-MM-yyyy")}`
    : "",

  "Account period end week date": d.account_period_end_week_date
    ? `\u200B${format(new Date(d.account_period_end_week_date), "dd-MM-yyyy")}`
    : "",

  "Discrepancy period date": d.discrepancy_period_date
    ? `\u200B${format(new Date(d.discrepancy_period_date), "dd-MM-yyyy")}`
    : "",

  "Discrepancy period blocks": d.discrepancy_period_blocks,
  "Discrepancy reason": d.discrepancy_reason,
  "Isresolved": d.isresolved,
  "Reasons": d.reasons,

   "Login_Link": `${window.location.origin}/login`
});
    }

    setExportData(finalData);

  } catch (error) {
    console.error("Error fetching export data:", error);
  }
}

    fetchData();
    fetchExportData();
  }, []);

  const headers = [
    { label: "Weekly account", key: "Weekly account" },
    {
      label: "Account period start week date ('dd-mm-yyyy')",
      key: "Account period start week date",
    },
    {
      label: "Account period end week date ('dd-mm-yyyy')",
      key: "Account period end week date",
    },
    {
      label: "Discrepancy period date ('dd-mm-yyyy')",
      key: "Discrepancy period date",
    },

    { label: "Discrepancy period blocks", key: "Discrepancy period blocks" },
    { label: "Discrepancy reason", key: "Discrepancy reason" },
    { label: "Isresolved", key: "Isresolved" },
    { label: "Reasons", key: "Reasons" },

     { label: "Login_Link", key: "Login_Link" }
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h4> WEEKLY ACCOUNT DATA</h4>
        <CSVLink
          data={exportData}
          headers={headers}
          filename={"Weeklyaccount.csv"}
          target="_blank"
          style={{
            textDecoration: "none",
          }}
        >
          <button
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
              fontWeight: "bold",
              transition: "background 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
          >
            📥 Download Weekly Account{" "}
          </button>
        </CSVLink>
      </div>

      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={apiData}
          columns={columns}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          components={{
            Toolbar: GridToolbar,
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
        />
      </Box>
    </div>
  );
}
